import { supabase } from '@/integrations/supabase/client';

export interface BugReportInsert {
  reporter_id: string;
  description: string;
  priority: 'blocking' | 'important' | 'minor';
  category: 'ui' | 'data' | 'performance' | 'navigation' | 'other';
  page_url: string;
  current_view: string | null;
  user_roles: string[];
  is_impersonating: boolean;
  impersonated_user_id: string | null;
  console_logs: unknown[] | null;
  browser_info: Record<string, unknown>;
  screenshot_url?: string | null;
}

export async function uploadBugScreenshot(
  reporterId: string,
  screenshotBlob: Blob
): Promise<{ success: boolean; url?: string; error?: unknown }> {
  try {
    const fileName = `${reporterId}/${Date.now()}.png`;
    const { error: uploadError } = await supabase.storage
      .from('bug-screenshots')
      .upload(fileName, screenshotBlob, { contentType: 'image/png' });

    if (uploadError) {
      console.error('Error uploading screenshot:', uploadError);
      return { success: false, error: uploadError };
    }

    const { data: urlData } = supabase.storage
      .from('bug-screenshots')
      .getPublicUrl(fileName);

    return { success: true, url: urlData.publicUrl };
  } catch (error) {
    console.error('Error in uploadBugScreenshot:', error);
    return { success: false, error };
  }
}

export async function submitBugReport(
  report: BugReportInsert
): Promise<{ success: boolean; id?: string; error?: unknown }> {
  try {
    const { data, error } = await supabase
      .from('bug_reports' as any)
      .insert(report as any)
      .select('id')
      .single();

    if (error) {
      console.error('Error submitting bug report:', error);
      return { success: false, error };
    }

    return { success: true, id: (data as any)?.id };
  } catch (error) {
    console.error('Error in submitBugReport:', error);
    return { success: false, error };
  }
}
